import React from "react";
import { ElementComponentProps } from "elements/types";

import { RadioElement } from "records/Element";
import RadioReactive from "./RadioReactive";
import RadioOnApply from "./RadioOnApply";
import { extractOnApplyParameters } from "elements/utils";

function RadioContainer(props: ElementComponentProps<RadioElement>) {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<RadioOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<RadioReactive {...props} />
	);
}

export default React.memo(RadioContainer);
